import React, { useContext } from "react";
import "./case-header-sticky.component.scoped.scss";
import { CaseContext, GlobalContext } from "../../store";
import Skeleton from "@material-ui/lab/Skeleton";
import CaseTabsComponent from "../case-tabs/case-tabs.component";
import CaseHeaderActionComponent from "../case-header-action/case-header-action.component";

export default function CaseHeaderStickyComponent(props: any) {
  const { loading } = useContext(CaseContext);
  const { fullNav, horizontalIcons } = useContext(GlobalContext);

  return (
    <div
      className={"case-header w-100 " + (fullNav ? "full-nav" : "")}>
      <div className="row no-gutters">
        <div className="left-header">
          {loading ? (
            <Skeleton variant="text" height={35} />
          ) : (
            <div className="tabs-sticky">
              <CaseTabsComponent />
            </div>
          )}
        </div>
        <div className="middle-header">
          <div className={'h-100 ' + (horizontalIcons ? 'd-block' : 'd-none')}>
            <CaseHeaderActionComponent display='horizontal' />
          </div>
        </div>
      </div>
    </div>
  );
}
